export default __webpack_public_path__ + "assets/2110581167ffae477f1ef329e6ff6261.png";